export default __webpack_public_path__ + "static/img/clouds-min.0c14236.png";